<template>
	<div>
        <vue-headful :title="dashboard.dashboard_name+' [Dashboard] :: MeritEHS'" />

	    <h4 class="mt-2 mb-4">
	    	<ol class="breadcrumb font-weight-bold m-0">
	    		<li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                    <router-link :to="`/`">
                        <i class="fa fa-dashboard"></i> Dashboard
                    </router-link>
                </li>
                <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                    <router-link :to="`/dashboards/settings`">
                        Settings
                    </router-link>
                </li>
                <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                    <router-link :to="`/dashboards/settings/view/${dashboard.id}`">
                        {{ dashboard.dashboard_name }}
                    </router-link>
                </li>
                <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                    {{ dashboard.is_subscribed ? 'Unsubscribe' : 'Subscribe' }}
                </li>
	    	</ol>
	    </h4>

        <div class="row mb-4">
            <div class="col-lg-6 col-md-8">
                <div class="card mb-4">
                    <div class="card-header">
                        Dashboard: {{ dashboard.dashboard_name }}
                    </div>
                    <div class="card-body">
                        <div class="alert" :class="{'alert-success': !dashboard.is_subscribed, 'alert-warning': dashboard.is_subscribed}">
                            Confirm you want to <strong>{{ dashboard.is_subscribed ? 'Unsubscribe from' : 'Subscribe to' }}</strong> this Dashboard
                        </div>
                    </div>
                </div>

                <button type="button" class="btn btn-sm" :class="{'btn-success': !dashboard.is_subscribed, 'btn-warning': dashboard.is_subscribed}" v-on:click="updateSubscription()">
                    {{ dashboard.is_subscribed ? 'Unsubscribe' : 'Subscribe' }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dashboard_id: this.$route.params.id,
                dashboard: {},
            }
        },

        watch: {

        },

        computed: {

        },

        methods: {

            getDashboard() {
                this.$http.get('/dashboards/settings/view/'+this.dashboard_id)
                .then(response => {
                    //SEt it
                    this.dashboard = response.data.dashboard;
                })
                .catch(err => {

                });
            },

            updateSubscription() {
                this.$http.post('/dashboards/settings/subscribe/'+this.dashboard_id)
                .then(response => {
                    //Alert the user?
                    if(this.dashboard.is_subscribed)
                    {
                        //Alert it
                        this.$toastr.success('Unsubscribed From Dashboard');
                    }
                    else
                    {
                        //Set it
                        this.$toastr.success('Subscribed to Dashboard');
                    }

                    //Send to the View
                    this.$router.push('/dashboards/settings/view/' + this.dashboard_id);

                })
                .catch(err => {

                });
            },
        },

        mounted() {
            this.getDashboard();
        }
    }
</script>